import React,{useState} from 'react'
import Page from "../../components/Page"
import Loader from '../../components/Loader/Loader'

export default function Description() {
    const [isLoading, setIsLoading] = useState(false);
  return (
   <>
     <Loader start={isLoading} />
      <Page>
    <button className="btn-procced btn-primary" style={{display:'block',float:'right'}}>Buy</button>
    
    <button className="btn-procced btn-primary" style={{display:'block',float:'right'}}>Buy</button>
    </Page>
   </>
  )
}
